<style lang="less" scoped>
    .selector{
        display: inline-block;
        width: 100%;
    }
    .selector /deep/ .ivu-poptip{
        width: 100%;
    }
    .selector /deep/ .ivu-poptip-rel{
        width: 100%;
    }
    .selector-btn{
        padding-left: 8px;
        text-align: left;
    }
    .select-poptip{
        width: 100%;
    }
    .select-poptip /deep/ .ivu-poptip-rel{
        width: 100%;
    }
    .type-text{
        padding: 10px 0;
        line-height: 1;
        border: none;
        margin-top: -2px;
        &:focus{
            box-shadow: none;
        }
    }
    .account-container{
        margin-top: 5px;
        height: 160px;
        overflow: auto;
    }
    .select-payee-account{
        display: block;
        margin: 5px;
        padding: 3px 6px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .select-payee-account:hover{
        background: #e5e5e5;
    }
    .selector-btn-deletable{
        padding-right: 25px;
        .delete-btn {
            display: inline-block;
            width: auto;
            position: absolute;
            top: 50%;
            right: 5px;
            transform: translate(0, -50%);
            &:hover {
                transform: translate(0, -50%) scale(1.5, 1.5);
            }
        }
    }
</style>
<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-height="500px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="textRender(type,selectedItem)"
        :label="label"
        :placeholder="placeholder"
        :disabled="!type"
        :required="required"
        :rules="rules"
        :clearable="clearable"
        readonly
        v-bind="attrs"
        @click:clear="clearData"
        v-on="on"
      />
    </template>
    <v-card
      max-width="500"
      class="mx-auto"
      style="height:100%"
    >
      <v-toolbar
        flat
      >
        <v-text-field
          v-model="params.search"
          hide-details
          append-icon="mdi-magnify"
          single-line
          clearable
          @keydown="keydown"
          @click:clear="search"
          @click:append="search"
        />
      </v-toolbar>

      <v-card-text>
        <v-progress-linear
          v-show="loading"
          indeterminate
          color="primary"
        />
        <div
          v-if="type === 'staff'"
          class="account-container"
        >
          <div
            v-for="customer in results"
            :key="customer.id"
            class="select-payee"
          >
            <span>{{ customer.team }} - </span>
            <span>{{ customer.account }}</span>
            <div
              v-if="customer.bank_number"
              class="select-payee-account"
              @click="setPayeeUser(customer, 'bank')"
            >
              <span>{{ customer.bank }} - </span>
              <span>{{ customer.bank_account ? customer.bank_account : customer.account }} - </span>
              <span>{{ customer.bank_number }}</span>
            </div>
            <div
              v-if="customer.bank2_number"
              class="select-payee-account"
              @click="setPayeeUser(customer, 'bank2')"
            >
              <span>{{ customer.bank2 }} - </span>
              <span>{{ customer.bank2_account ? customer.bank2_account : customer.account }} - </span>
              <span>{{ customer.bank2_number }}</span>
            </div>
            <div
              v-if="customer.alipay"
              class="select-payee-account"
              @click="setPayeeUser(customer, 'alipay')"
            >
              <span>支付宝 - </span>
              <span>{{ customer.account }} - </span>
              <span>{{ customer.alipay }}</span>
            </div>
            <div v-if="!customer.bank_number && !customer.alipay">
              <span>该员工没有录入银行信息</span>
            </div>
          </div>
        </div>
        <div v-else-if="type==='company'">
          <div
            v-for="company in results"
            :key="company.id"
            :class="{'color-error': company.is_abnormal}"
          >
            <div class="text-bold">
              <span>{{ company.name }}</span>
              <span v-if="company.company_type === 0">- {{ company.id_number || '未录入证件信息' }}</span>
            </div>
            <div v-if="company.is_abnormal">
              <span>已被列入黑名单: </span>
              <span v-html="company.abnormal_reason" />
            </div>
            <div
              v-for="account in company.payee_company_accounts"
              :key="account.id"
              class="select-payee-account"
              @click="setPayeeCompany(company, account)"
            >
              <span>{{ account.bank }} - </span>
              <span>{{ account.account }} - </span>
              <span>{{ account.bank_number }}</span>
              <span
                v-if="account.bank_type === 0 && !account.bank_code"
                class="color-error"
              >
                (未录入联行号，可能会导致无法付款)
              </span>
            </div>
          </div>
        </div>
        <div
          v-else-if="type==='clients'"
          class="account-container"
        >
          <div
            v-for="client in clientsc"
            :key="client.id"
            class="select-payee"
          >
            <div
              class="select-payee-account"
              @click="setPayeeClient(client, 'bank')"
            >
              <span>{{ client.name }}-{{ client.kingdee_uid }} </span>
            </div>
          </div>
        </div>
        <div v-else-if="type==='our_company'">
          <div
            v-for="ccompany in ccompanies"
            :key="ccompany.id"
            class="select-payee"
          >
            <div
              class="select-payee-account"
              @click="setInstitutionalFramework(ccompany)"
            >
              <span>{{ ccompany.name }}</span>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>
<script>
  import { http } from '@/libs/util'
  import { mapGetters } from 'vuex'
  export default {
    props: {
      label: {
        type: String,
        default: '选择日期'
      },
      placeholder: {
        type: String,
        default: '选择供应商'
      },
      type: {
        type: String,
        default: undefined
      },
      textRender: {
        type: Function,
        default: () => {}
      },
      required: {
        type: Boolean,
        default: false
      },
      rules: {
        type: Array,
      },
      clearable: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        menu: false,
        date: '',
        params: {
          search: '',
          type: '',
          apply_user_id: 0
        },
        selectedItem: null,
        loading: false,
        results: [],
      }
    },
    created() {
      this.init();
    },
    computed: {
      ...mapGetters('async', ['clients', 'companies']),
      clientsc() {
        if (this.type !== 'clients') {
          return []
        }
        return this.clients.filter(item => {
          if (!this.params.search || (this.params.search && !this.params.search.trim())) {
            return true
          }
          let index = 0
          for (let i = 0; i < item.name.length; i++) {
            if (item.name[i] === this.params.search[index]) {
              index++
              if (index === this.params.search.length) {
                return true
              }
            }
          }
          return false
        })
      },
      ccompanies() {
        if (this.type !== 'our_company') {
          return []
        }
        return this.companies.filter(item => {
          if (!this.params.search || (this.params.search && !this.params.search.trim())) {
            return true
          }
          let index = 0
          for (let i = 0; i < item.name.length; i++) {
            if (item.name[i] === this.params.search[index]) {
              index++
              if (index === this.params.search.length) {
                return true
              }
            }
          }
          return false
        })
      }
    },
    methods: {
      keydown({code}) {
        if (code === 'Enter') {
          this.search()
        }
      },
      setPayeeUser(customer, bank) {
        this.menu = false
        const account_obj = {};
        account_obj.payee_company_id = 0;
        account_obj.payee_company = '';
        account_obj.payee_company_account_id = 0;
        account_obj.payee_user_id = customer.id;
        account_obj.payee_user = customer.account;
        switch (bank) {
        case 'bank':
          account_obj.payee_bank = customer.bank;
          account_obj.payee_bank_number = customer.bank_number;
          account_obj.payee_account_name = customer.bank_account ? customer.bank_account : customer.account;
          break;
        case 'bank2':
          account_obj.payee_bank = customer.bank2;
          account_obj.payee_bank_number = customer.bank2_number;
          account_obj.payee_account_name = customer.bank2_account ? customer.bank2_account : customer.account;
          break;
        case 'alipay':
          account_obj.payee_bank = '支付宝';
          account_obj.payee_bank_number = customer.alipay;
          account_obj.payee_account_name = customer.account;
          break;
        default:
          console.error('未定义银行类型');
          break;
        }
        this.selectedItem = account_obj
        this.$emit('on-change', account_obj);
        this.$parent.$emit('on-form-blur');
        document.body.click();
      },
      setPayeeCompany(company, account) {
        this.menu = false
        const account_obj = {};
        account_obj.payee_user_id = 0;
        account_obj.payee_user = '';
        account_obj.payee_company_id = company.id;
        account_obj.payee_company = company.name;
        account_obj.payee_company_account_id = account.id;
        account_obj.payee_bank = account.bank;
        account_obj.payee_account_name = account.account;
        account_obj.payee_bank_number = account.bank_number;
        this.selectedItem = account_obj
        this.$emit('on-change', account_obj);
        this.$parent.$emit('on-form-blur');
      },
      setPayeeClient(client) {
        this.menu = false
        const account_obj = {};
        account_obj.name = client.name
        account_obj.kingdee_uid = client.kingdee_uid
        account_obj.id = client.id
        this.selectedItem = account_obj
        this.$emit('on-change', client);
      },
      setInstitutionalFramework(ccompany) {
        this.menu = false
        const account_obj = {};
        account_obj.company_id = ccompany.id;
        account_obj.company_name = ccompany.name
        this.selectedItem = account_obj
        this.$emit('on-change', account_obj);
      },
      init() {
        this.selectedItem = null
        this.params.type = this.type;
        this.params.apply_user_id = this.apply_user_id;
        this.params.search = ''
      },
      setSelectedItem(selectedItem) {
        this.selectedItem = selectedItem
      },
      clearData() {
        this.$emit('on-change');
      },
      search() {
        if (this.loading || !this.type) return;
        this.results = []
       
        let api = null
        switch (this.type) {
        case 'staff':
          // eslint-disable-next-line
          api = Util.api.query_customer_with_customer_account
          break;
        case 'company':
          // eslint-disable-next-line
          api = Util.api.query_payee_company_account
          break;
        case 'clients':
          return
        default:
          break;
        }
        if (!api) {
          return 
        }

        this.loading = true
        http.cacheGet(api, {
          ...this.params,
          type: this.type
        }).then((res) => {
          switch (this.type) {
          case 'staff':
            this.results = res || [];
            break;
          case 'company':
            this.results = res.payee_companies || [];
            break;
          default:
            break;
          }
        }).finally(() => {
          this.loading = false
        }) 
      },
    }
  }
</script>
